import type {CreatePaymentWayRequest} from '@rocket-ui/lk-api';
import {
	extractAccountDigits,
	extractBikDigits,
	extractCardDigits,
	formatPhoneForApi,
	isCardNumberValid,
	PaymentDetailsValues,
} from './paymentDetails';
import {RegistrationPaymentMethod} from './paymentMethod';

export const buildPaymentWayRequest = (
	method: RegistrationPaymentMethod,
	details: PaymentDetailsValues,
): CreatePaymentWayRequest | null => {
	const bik = details.selectedBank?.bik ?? extractBikDigits(details.bik);

	if (!bik) {
		return null;
	}

	switch (method) {
		case 'sbp_account': {
			const phone = formatPhoneForApi(details.phone);

			if (!phone) {
				return null;
			}

			return {
				type: method,
				bik,
				phone,
				isPrimary: details.isPrimary,
			};
		}
		case 'bank_card': {
			const cardNumber = extractCardDigits(details.card);

			if (!isCardNumberValid(cardNumber)) {
				return null;
			}

			return {
				type: method,
				bik,
				cardNumber,
				isPrimary: details.isPrimary,
			};
		}
		case 'executor_account': {
			const account = extractAccountDigits(details.account);

			if (!account) {
				return null;
			}

			return {
				type: method,
				bik,
				account,
				isPrimary: details.isPrimary,
			};
		}
		default:
			return null;
	}
};
